// Environment determines if we send cookies or not
export const Environment: string = 'production'; // values: 'demo' or 'production'
export const useJWT: boolean = true;

// const demoUrl = 'http://localhost:5001/api';
const demoUrl = 'https://mudman-dev.novamudlabs.com/api';
const productionUrl = 'https://' + window.location.hostname + '/api';

export const ApiURL = (process.env.NODE_ENV === 'production' ) ? productionUrl : demoUrl;

export const colors = {};



// WEBPACK FOOTER //
// ./src/Constants/index.tsx